import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/glob/icon_arrow_right.png';
import _imports_1 from '@/assets/images/glob/icon_arrow_left.png';
const _withScopeId = n => (_pushScopeId("data-v-8a9cb046"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container-xl"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "empty-img"
}, null, -1));
const _hoisted_4 = {
  class: "container-xl swiper-box"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "item-desc"
};
import { reactive } from 'vue';
import subTitle from '@/components/sub-title';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
export default {
  __name: 'index',
  setup(__props) {
    const officeImageList = [require('../../assets/images/office/10.png'), require('../../assets/images/office/5.png'), require('../../assets/images/office/8.png'), require('../../assets/images/office/9.png'), require('../../assets/images/office/11.png'), require('../../assets/images/office/1.png'), require('../../assets/images/office/2.png'), require('../../assets/images/office/3.png'), require('../../assets/images/office/4.png'), require('../../assets/images/office/6.png'), require('../../assets/images/office/7.png')];

    // 轮播数量
    let slideNum = reactive(4);
    if (window.screen.width <= 1024) {
      slideNum = reactive(1);
    }
    const productList = [{
      img: require('../../assets/images/product/img1.jpg'),
      desc: 'SIM-500设备在线监测系统'
    }, {
      img: require('../../assets/images/product/img2.jpg'),
      desc: 'SED-560开关柜智能终端'
    }, {
      img: require('../../assets/images/product/img3.jpg'),
      desc: 'FTU配电自动化馈线终端'
    }, {
      img: require('../../assets/images/product/img4.jpg'),
      desc: 'DTU配电自动化站所终端'
    }];
    const modules = [Navigation, Pagination, Scrollbar, A11y, Autoplay];
    let swiperApi = null;
    const onSwiper = swiper => {
      swiperApi = swiper;
    };
    const nextClick = () => {
      if (swiperApi.previousIndex === 3) {
        swiperApi.slideTo(0);
      } else {
        swiperApi.slideNext();
      }
    };
    const prevClick = () => {
      if (swiperApi.previousIndex === 1 || swiperApi.previousIndex === undefined) {
        swiperApi.slideTo(3);
      } else {
        swiperApi.slidePrev();
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(subTitle), {
        info: {
          title: '办公场所',
          desc: 'Office Space'
        }
      }), _createElementVNode("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(officeImageList, (item, index) => {
        return _createElementVNode("img", {
          key: index,
          class: "office-img object-fit-cover",
          src: item
        }, null, 8, _hoisted_2);
      }), 64)), _hoisted_3]), _createVNode(_unref(subTitle), {
        info: {
          title: '产品展示',
          desc: 'Product Display'
        }
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_unref(Swiper), {
        navigation: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        "slides-per-view": _unref(slideNum),
        "space-between": 30,
        modules: modules,
        onSwiper: onSwiper
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...productList, ...productList], (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
              class: "item-img",
              src: item.img
            }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.desc), 1)])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["slides-per-view"]), _createElementVNode("img", {
        class: "next-icon",
        src: _imports_0,
        onClick: nextClick
      }), _createElementVNode("img", {
        class: "pre-icon",
        src: _imports_1,
        onClick: prevClick
      })])], 64);
    };
  }
};